//common
import { useLoaderData } from "react-router-dom";
import { DetectionListEntry } from "./DetectionListPageDetectionItem";
import { ObbRun } from "./api/Application";

export function DetectionRunListPage() {
    const runs = useLoaderData() as ObbRun[] ?? [];
    return <div className="h-100">
        <div id="capture-list-page">
            <div id="capture-list" style={{ display: "grid", gridTemplateRows: "auto auto 1fr" }}>
                <div className="bg-body-tertiary border d-flex flex-row w-100 justify-content-center align-items-center gap-2 p-2">
                    <div className="flex-grow-1 ps-2 fs-5">
                        Detection Runs
                    </div>
                </div>
                <div className="y-scroll-auto">
                    {runs.map( x => {
                        return <div>
                            
                        </div>
                    })}
                </div>
            </div>
            <div className="image-viewer h-100 overflow-hidden position-relative" style={{ backgroundColor: "black" }}>

            </div>
        </div>
    </div>;
}